export class WorkflowsRightsGroupsForm {
  groupeIds: number[];
}
